import React, {useEffect,useState} from 'react';
import {FormValidator, useFormValidator, Inputs } from 'coaz-ui';
import client from '../client';

const EditUserType = ({params, submitRef, setLoading, setEnableSubmit}) => {
    const [userType,setUserType] = useState(null);
    const [criteriaPaths,setCriteriaPaths] = useState([]);
    const minWidth = 240;
    const [inputWidth,setInputWidth] = useState(minWidth);
    const {request,errorMessage} = client;

    const submit = async (e) => {
        try {
            const response = await request("PUT","usertypes", userType);

            if (response && response.ref) {
                return {
                    message: 'Successful',
                    success: true
                };
            }

            return {
                message: errorMessage(response)
            };
        } catch (error) {
            return {
                message: errorMessage(error)
            };
        }
    };

    const [register,handleChange,handleSubmit,errors] = useFormValidator(submit);

    const inputs = [
        {
            label:'name',
            type:'text', 
            name:'name',
            value:userType && userType.name?userType.name:'',   
            placeholder:'Enter name...',
            onChange:(e) => {handleChange(e,onChange)},
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Tariff Applicable',
            type:'checkbox',
            name:'tariffApplicable',
            value:userType?userType.tariffApplicable:false,   
            onChange:(e) => {
                setUserType({...userType,tariffApplicable: !userType.tariffApplicable});
            }
        },
        {
            label:'Criteria paths',
            type:'select',
            options:() => {
                let options = [];
                userType && userType.tariffApplicable && criteriaPaths.map((option,i) => options.push(<option key={i} value={option.id}>{option.id}</option>));
                return options;
            },
            name:'criteriaPathItemId', 
            value:userType && userType.criteriaPathItemId?userType.criteriaPathItemId:'',
            disabled:userType && !userType.tariffApplicable,
            onChange:(e) => handleChange(e,onCriteriaPath)
        }
    ]

    const onChange = (e) => {
        const value = e.target.value;
        if(value === '') {
            setUserType({...userType, [e.target.name]: null});
        } else {
            setUserType({...userType, [e.target.name]: value});
        }
    }

    const onCriteriaPath = (e) => {
        if(e.target.value === '') {
            setUserType({...userType, criteriaPathItemId: null});
        } else {
            let value = criteriaPaths.find((path) => {return path.id == e.target.value});
            setUserType({...userType, criteriaPathItemId: value.id});
        }
    }

    useEffect(() => {
        if (handleSubmit) {
            submitRef.current = { submit: handleSubmit };
            setEnableSubmit(true);
        } else {
            submitRef.current = null;
            setEnableSubmit(false);
        }

        return () => {
            submitRef.current = null;
        };
    }, [handleSubmit]);

    useEffect(() => {
        ( async () => {
            if(!params || !params.id) return;
			setLoading && setLoading(true);
            let usrType = null;
            await request('GET',`usertypes/${params.id}`)
            .then((response) => {
                setLoading(false);
                if(response && response.ref) {
                    usrType = response;
                }
            })
            .catch((error) => {
                console.log(error);
            })
            await request('GET','criteriapathitems')
            .then((response) => {
                if(response && response.length > 0) {
                    setCriteriaPaths(response);
                    if(usrType && usrType.tariffApplicable && usrType.criteriaPathItemId) {
                        let found = response.find((path) => {return path.id == usrType.criteriaPathItemId});
                        if(!found) {
                            usrType.criteriaPathItemId = response[0].id;
                        }
                    } else if(usrType && usrType.tariffApplicable) {
                        usrType.criteriaPathItemId = response[0].id;
                    } else if(usrType) {
                        usrType.criteriaPathItemId = null;
                    }
                } else {
                    setCriteriaPaths([]);
                    usrType.criteriaPathItemId = null;
                }
            })
            
            setUserType(usrType);
            setLoading && setLoading(false);
        }
        )();
    },[]);

    return (
        <FormValidator>
            <div className='flex flex-col w-full h-auto'>
                <div className='flex flex-col w-full h-auto space-y-4 shrink-0'>
                    <Inputs inputs={inputs} minWidth={minWidth} onSubmit={handleSubmit}/>
                </div>
            </div>
        </FormValidator>
      )
}

export default EditUserType